<template>
  <div class="index">
    <div class="index-con">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>Conference</span> <b>→</b>
        <span>ADC - Asia-Pacific Drying Conference </span>
      </div>
      <div class="title">Asia-Pacific Drying Conference (ADC)</div>
      <div class="box">
        <div class="box-title">ADC Introduction</div>
        <div class="text">
          After a successful launch in 1978 of the IDS series of biennial conferences
          devoted to drying science, engineering and technology, Professor Mujumdar used
          to receive numerous suggestions and requests to hold a similar meeting in Asia
          as interested researchers could not afford to travel far to venues in the USA,
          Europe or Australia for IDS meetings. This motivated Professor Abdul Kamaruddin
          of Bogor University in Indonesia and Professor Mujumdar to establish the
          Asia-Pacific Drying Conference series in 1997. The first meeting was held in
          Bali. Later meetings were held in Malaysia (twice), India (twice), China,
          Thailand, Hong Kong, and the 2021 ADC will be held in Viet Nam.
        </div>
        <br />
        <div class="text">
          The most recent ADC was held in Vadodara, India, with major international and
          industry participation. Reports on various ADC meetings have appeared in the
          archival journal Drying Technology. Selected peer-reviewed papers presented at
          various ADC conferences have appeared in this journal.
        </div>
        <br />
        <div class="text text-right">——Professor Arun S. Mujumdar</div>
        <br />
        <div class="text text-right">
          <a href="https://arunmujumdar.com/adc/"> https://arunmujumdar.com/adc/ </a>
        </div>
        <div class="box-title">Upcoming ADC Conferences</div>

        <div class="card">
          <div class="card-title">12nd Asia-Pacific Drying Conference</div>
          <div class="left">
            <p>October 24-27, 2025</p>
            <p>Changzhou, China</p>
            <br />
            <p>Organizer: China Agricultural University</p>
            <p>Website: www.adccdc2025.com</p>
          </div>
        </div>
        <div class="box-title">Previous ADC Conferences</div>
        <div class="text text-center">
          <p v-for="(i, num) in list" :key="num">{{ i.label }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          label: "1st Asia-Pacific Drying Conference (ADC 1999): Bali, Indonesia",
        },
        {
          label: "2nd Asia-Pacific Drying Conference (ADC 2001): Penang, Malaysia",
        },
        {
          label: "3rd Asia-Pacific Drying Conference (ADC 2003): Bangkok, Thailand",
        },
        {
          label: "4th Asia-Pacific Drying Conference (ADC 2005): Kolkata, India",
        },
        {
          label: "5th Asia-Pacific Drying Conference (ADC 2007): Hong Kong, China",
        },
        {
          label: "6th Asia-Pacific Drying Conference (ADC 2009): Bangkok, Thailand",
        },
        {
          label: "7th Asia-Pacific Drying Conference (ADC 2011): Tianjin, China",
        },
        {
          label: "8th Asia-Pacific Drying Conference (ADC 2015): Kuala Lumpur, Malaysia",
        },
        {
          label: "9th Asia-Pacific Drying Conference  (ADC 2017): Wuxi, China",
        },
        {
          label: "10th Asia-Pacific Drying Conference (ADC 2019): Vadodara, India",
        },
        {
          label: "11th Asia-Pacific Drying Conference (ADC 2023): Kolkata, India",
        },
        {
          label: "12th Asia-Pacific Drying Conference (ADC 2025): Changzhou, China",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .small-title {
    margin: 25px 0;
    font-weight: 600;
  }

  .card {
    padding: 25px 15px;
    box-sizing: border-box;
    position: relative;
    font-weight: 700;
    line-height: 1.9;
    background-color: hsla(0, 0%, 50.2%, 0.05);

    .card-title {
      color: #5b965a;
      margin-bottom: 20px;
    }

    img {
      position: absolute;
      bottom: 30px;
      right: 105px;
      width: auto;
      height: 150px;
    }
  }

  .box {
    padding: 0 100px;
    box-sizing: border-box;
  }

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    width: 600px;
    margin: 0 auto;
  }

  .text-green {
    color: #5b965a;
  }

  .title {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 580px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .box-title {
    text-align: center;
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    width: 100%;
    margin-top: 50px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 400px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 11px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}
@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
    }

    .box-title {
      font-size: 18px;
    }

    .box {
      padding: 0 10px;
    }

    .text-center {
      width: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/adc.vue